//Editor HTML
import { NgxEditorModule } from 'ngx-editor';
import { DialogDescripcionComponent } from '../component/dialog-descripcion/dialog-descripcion.component';
import { SnackbarComponent } from '../views/snackbar/snackbar.component';


//Crear PDF
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
// import { reducer } from '../redux/app.reducers';
import { MyMonitoringService } from '@services/microsoft/applicationInsights.services';
// import { RollbarErrorHandlerService, rollbarFactory, RollbarService } from '@services/error/rollbarErrorHandler.service';

import { AppRoutingModule } from '../app-routing.module';
import { AuthGuardService } from '@guards/auth-guard/auth-guard.service';
import { DocumentoModule } from './documento.module';
import { ReactiveFormsModule } from '@angular/forms';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppComponent } from '../app.component';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';

// importar locales
import localePy from '@angular/common/locales/es-PY';
import localePt from '@angular/common/locales/pt';
import localeEn from '@angular/common/locales/en';
import localeEsAr from '@angular/common/locales/es-AR';

//App

import { IConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { SharedModule } from './shared.module';
import { CanDeactivateGuard } from '../directives/can-deactivate/can-deactivate.guard';
import { GlobalHttpErrorInterceptorService } from '../interceptors/error-interceptor/error-interceptor.service';
import { LayoutModule } from '@angular/cdk/layout';
import { provideHotToastConfig } from '@ngneat/hot-toast';

// registrar los locales con el nombre que quieras utilizar a la hora de proveer
registerLocaleData(localePy, 'es');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEsAr, 'es-Ar');

//ngx-markdown
// import 'prismjs';
// import 'prismjs/components/prism-typescript.min.js';
// import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
// import 'prismjs/plugins/line-highlight/prism-line-highlight.js';

//Breadcrum
// import { NgDynamicBreadcrumbModule } from "ng-dynamic-breadcrumb";

//Manejo de Errores
import { AuthInterceptorService } from 'src/app/interceptors/auth/auth-interceptor.service';
import { BreadcrumbItemDirective } from 'xng-breadcrumb';

//Graficos
import { Chart } from 'chart.js';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ComponentModule } from './component.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { BrowserModule } from '@angular/platform-browser';

//Configuracion Mascaras


const maskConfig: Partial<IConfig> = {
  validation: false,
};

const maskConfigFunction: () => Partial<IConfig> = () => {
  return {
    validation: false,
  };
};

// Microsfot Application Insights
// @Injectable()
// export class ErrorHandlerService extends ErrorHandler {

//   constructor(@Inject(MyMonitoringService) private myMonitoringService: MyMonitoringService) {
//     super();
//   }
//   handleErrorInsights(error: Error) {
//     this.myMonitoringService.logException(error); // Manually log exception
//   }
// }

@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    DocumentoModule,
    LayoutModule,
    ComponentModule,
    CommonModule,
    //BreadcrumbModule https://udayvunnam.github.io/xng-breadcrumb/#/quickstart
    // BreadcrumbModule,
    //NGX Mask https://www.npmjs.com/package/ngx-mask
    // NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    //Breadcrum
    //NgDynamicBreadcrumbModule,
    //Spinner https://www.npmjs.com/package/ngx-spinner
    BreadcrumbItemDirective,
    BrowserAnimationsModule,
    NgxSpinnerModule,

    //
    AppRoutingModule,
    ReactiveFormsModule,
    //Editor HTML
    NgxEditorModule,
    EditorModule,
    FullCalendarModule,


    //Notifaciones : https://github.com/ngneat/hot-toast#installation
    // HotToastModule.forRoot({
    //   reverseOrder: true,
    //   dismissible: true,
    //   position: 'bottom-right',
    //   autoClose: true,
    // }),

    //Redux
    // StoreModule.forRoot(reducer),
    // StoreDevtoolsModule.instrument({
    //   maxAge: 5,
    //   logOnly: environment.production
    // })
  ],
  declarations: [
    AppComponent,

  ],
  providers: [
    AuthGuardService,
    CanDeactivateGuard,
    AuthInterceptorService,
    MyMonitoringService,
    //locales
    { provide: LOCALE_ID, useValue: 'es-Ar' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: '$' },
    //RollbarService
    // { provide: ErrorHandler, useClass: RollbarErrorHandlerService },
    // { provide: RollbarService, useFactory: rollbarFactory },

    // Microsfot Application Insights
    //{ provide: ErrorHandler, useClass: ErrorHandlerService },
    //Error Service
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpErrorInterceptorService,
      multi: true,
    },
    provideEnvironmentNgxMask(maskConfigFunction),

    //Autenticacion
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    provideHotToastConfig({
      reverseOrder: true,
      dismissible: true,
      position: 'bottom-right',
      autoClose: true,
    }),
  ],
  exports: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {

}
